

import searchArea from "./search/area.js";
import searchTerms from "./search/terms.js";
import SearchMap from "./search/map/index.js";
import estateIndex from "./estate/index.js";
import estateDetail from "./estate/detail.js";
import { homeCampaigns, homeAreaSearch, homeHero } from "./home/index.js";

const pages = () => {
    homeHero();
    homeCampaigns();
    homeAreaSearch();
    searchArea();
    searchTerms();
    SearchMap();
    estateIndex();
    estateDetail();
};
export default pages;
